import React, { useState, useEffect, useRef } from 'react';

const VideoThumbnail = ({ video, onPlay }) => {
    const [isVisible, setIsVisible] = useState(false);
    const thumbnailRef = useRef();

    useEffect(() => {
        const currentRef = thumbnailRef.current;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        if (currentRef) observer.unobserve(currentRef);
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (currentRef) observer.observe(currentRef);

        return () => {
            if (currentRef) observer.unobserve(currentRef);
        };
    }, []);

    const bytesToMB = (bytes) => (bytes / 1048576).toFixed(1);


    const getTagCategoryClass = (tag) => {
        if (['Taucher', 'Freitaucher', 'Tauchdrohne'].includes(tag)) return 'tag-blue';
        if (['Karpfen', 'Hecht', 'Goldfisch', 'Flussbarsch', 'Sonnenbarsch', 'Rotauge', 'Karausche', 'Flusskrebs', 'Wels', 'Aal', 'Kormoran'].includes(tag)) return 'tag-green';
        return 'tag-gray';
    };

    const handlePlayClick = (selectedVideo) => {
        const newUrl = `${window.location.origin}/?findVideo=${selectedVideo.filename}`;
        window.history.pushState({}, '', newUrl);
        onPlay(selectedVideo);
    };

    return (
        <div ref={thumbnailRef} className="thumbnail" data-filename={video.filename}>
            {isVisible ? (
                <>
                    {video.videoUrl.includes('timelapse') && <div className="timelapse-label">Zeitraffer</div>}
                    <img className="thumbnail_img" src={video.thumbnailUrl} alt={`Thumbnail for ${video.creationDate} ${video.creationTime}`} onClick={() => handlePlayClick(video)} />
                    <div className="thumbnail-text">
                        <p><span className="bold-text">Datum: </span><span className="light-text">{video.creationDate}</span></p>
                        <p><span className="bold-text">Uhrzeit: </span><span className="light-text">{video.creationTime}</span></p>
                        <p><span className="bold-text">Dateigröße: </span><span className="light-text">{bytesToMB(video.size)} MB</span></p>
                        <p><span className="bold-text">Dauer: </span><span className="light-text">{video.duration}</span></p>
                        <div className="video-tags">{video.tags && video.tags.length > 0 && video.tags.map((tag, index) => <span key={index} className={`video-tag ${getTagCategoryClass(tag)}`}>{tag}</span>)}</div>
                    </div>
                    <div className="download-icon"><a href={video.videoUrl} download target="_blank" rel="noreferrer"><img src="download.png" alt="Download Icon" /></a></div>
                </>
            ) : (
                <div className="thumbnail-placeholder">Loading...</div>
            )}
        </div>
    );
};

export default VideoThumbnail;
